import { useHistory } from "react-router"
import { useProfileImage } from "../customHooks/useProfileImage"
import { MatchUser } from "../models/api/MatchUser"
import { APP_LOGO, rootStore } from "../StApp"

export const MatchTrayItem = (props:{user: MatchUser})=>{

    const history = useHistory()
    const user = props.user
    const {imgUrl} = useProfileImage(user.uid,0, APP_LOGO)

    function openChat(){
        rootStore.mainStore.setCurrentImChatMeta({
            convStarted: false,
            uid: user.uid,
            userName: user.name
        })
        history.push('/stapp/imChat')
    }


    return(
        <div className='match-tray-item' onClick={openChat} 
        style={{backgroundImage: `url(${imgUrl})` }} >

        </div>
    )
}